<div class="student-tasks-preview" [ngStyle]="{'width': getWidth(card_format), 'font-size': getFont(card_format)}" style="margin-left: 0">
  <span class="preview-number"> {{index + 1}}.</span>
  <p class="exercise-hint" *ngIf="exercise.hint">{{exercise.hint}}</p>
  <ng-katex *ngIf="isKatexFormat(exercise)" class="exercise-text" [equation]="exercise.text"></ng-katex>
  <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" class="exercise-text" [paragraph]="getText | exerciseFormat:'text'"></ng-katex-paragraph >
  <ng-container *ngIf="exercise.questions && exercise.questions.length">
      <br>
      <ng-katex class="exercise-text" [equation]="getQuestionsText(exercise)"></ng-katex>
  </ng-container>
  <div *ngIf="exercise.words && exercise.words.length && !exercise.hint" class="answer-vars">
      <span *ngFor="let word of exercise.words" class="answer-var">{{ word.word }},</span>
  </div>
</div>